module.exports = __webpack_public_path__ + "static/media/loading-spinner.2d606956.svg";